/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * * `netcdf4` - netcdf4
 * @export
 */
export const NetCDFFileTypeEnum = {
  NETCDF4: "netcdf4",
} as const;
export type NetCDFFileTypeEnum = (typeof NetCDFFileTypeEnum)[keyof typeof NetCDFFileTypeEnum];

export function instanceOfNetCDFFileTypeEnum(value: any): boolean {
  for (const key in NetCDFFileTypeEnum) {
    if (Object.prototype.hasOwnProperty.call(NetCDFFileTypeEnum, key)) {
      if (NetCDFFileTypeEnum[key as keyof typeof NetCDFFileTypeEnum] === value) {
        return true;
      }
    }
  }
  return false;
}

export function NetCDFFileTypeEnumFromJSON(json: any): NetCDFFileTypeEnum {
  return NetCDFFileTypeEnumFromJSONTyped(json, false);
}

export function NetCDFFileTypeEnumFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): NetCDFFileTypeEnum {
  return json as NetCDFFileTypeEnum;
}

export function NetCDFFileTypeEnumToJSON(value?: NetCDFFileTypeEnum | null): any {
  return value as any;
}

export function NetCDFFileTypeEnumToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean
): NetCDFFileTypeEnum {
  return value as NetCDFFileTypeEnum;
}
